// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger } from 'bernie-logger';

// mobx
import { action, makeObservable, observable } from 'mobx';

// data
import { Product } from 'models';
import { ProductSource } from '../sources';

export class ProductStore extends Store {
  public products: Product[];

  public constructor(private productSource: ProductSource, state: SerializedData = {}, logger: Logger) {
    super(state, logger);

    makeObservable(this, {
      getProducts: action,
      getProduct: action,
      setProducts: action,
      products: observable,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.productSource, data.productSource);
  }

  public getProducts(programName: string): Product[] {
    return this.productSource.getProducts(programName);
  }

  public getProduct(programName: string, productName: string): Product {
    return this.getProducts(programName).find((product) => product.name === productName);
  }

  public setProducts(programName: string): void {
    const products = this.getProducts(programName);
    this.products = products;
  }
}
